<template>
  <div class="main-container landing">
    <HeaderAppLanding
      @openBag="$refs.EmotionBag.open()"
      @openBagWorld="$refs.EmotionBag.open(true)"
    />
    <transition name="fade-transition">
      <router-view />
    </transition>

    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: rgba(255, 255, 255, 0.55); stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
  </div>
</template>

<script>
import HeaderAppLanding from "./components/HeaderAppLanding";
import CurveShape from "./components/CurveShape";

export default {
  components: {
    HeaderAppLanding,
    CurveShape,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss">
@import "./scss/style.scss";
@import "./scss/custom.scss";
</style>
